module.exports = __webpack_public_path__ + "img/th-box4-text-light.01e817ee.png";